import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import DetailAnswer from 'src/components/patients/answers/DetailAnswer';
import DetailHistoryList from 'src/components/patients/answers/DetailHistoryList';
import DialogForm from 'src/components/patients/answers/dialog/DialogForm';
import { getAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';

const PatientAnswers = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const patientid = searchParams.get('id');
  const [dataAnswers, setDataAnswers] = useState<any>(null);
  const [logAnswer, setLogAnswer] = useState<any>(null);
  const [openForm, setOpenForm] = useState(false);

  const getAnswer = () => {
    const token = getToken();
    if (!token) {
      throw new Error('Failed to get access token');
    }
    getAPI(`/staff/answers?patient_id=${patientid}&token=${token}`)
      .then((res) => {
        if (res.code === 200) {
          setDataAnswers(res.data);
          setLogAnswer(res.data ? res.data[0] : []);
        }
      })
      .finally(() => {});
  };

  useEffect(() => {
    if (!patientid) {
      navigate(`/patients`);
    }
    getAnswer();
    // eslint-disable-next-line
  }, [patientid]);

  const handleUpdateClick = () => {
    setOpenForm(true);
  };
  const handleRowClick = (log: any) => {
    setLogAnswer(log);
  };

  const handleCloseDialogForm = () => {
    setOpenForm(false);
  };

  const handleSubmitForm = () => {
    getAnswer();
  };

  return (
    <>
      <Stack direction={'row'} spacing={'20px'}>
        <Stack width={'470px'}>
          <Typography
            fontSize={'20px'}
            fontWeight={500}
            color={'primary.dark'}
            mt={'18px'}
            mb={'16px'}
          >
            問診表
          </Typography>
          <Stack spacing={'20px'} width={'auto'}>
            <DetailAnswer answer={logAnswer} />
          </Stack>
        </Stack>
        <Stack flex={1}>
          <Typography
            fontSize={'20px'}
            fontWeight={500}
            color={'primary.dark'}
            mt={'18px'}
            mb={'16px'}
          >
            変更履歴
          </Typography>
          <Stack
            direction={'row'}
            spacing={'20px'}
            width={'100%'}
            sx={{
              '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before':
                { backgroundColor: '#CCD1D9' },
            }}
          >
            <SimpleBar style={{ maxHeight: '564px', width: '100%' }}>
              <DetailHistoryList
                dataAnswers={dataAnswers}
                handleRowClick={handleRowClick}
              />
            </SimpleBar>
          </Stack>
          <Stack direction={'row'} justifyContent={'space-between'} mt={'32px'}>
            <Stack direction={'row'} spacing={'8px'}>
              <BtnOutlineGradient
                text='更新'
                handleButtonClick={handleUpdateClick}
              />
              {/* <BtnOutlineGradient
              text='カルテ'
              handleButtonClick={handleSchemaClick}
            /> */}
            </Stack>
            {/* {patientid && (
            <Button
              onClick={() => handleDeleteClick(patientid)}
              sx={{
                p: '0',
                width: '80px',
                height: '32px',
                backgroundColor: 'primary.light',
                borderRadius: '4px',
                '&:hover': { opacity: 0.8, backgroundColor: 'primary.light' },
                border: '2px solid #DA4453',
              }}
            >
              <Typography
                fontWeight='700'
                lineHeight={'28px'}
                height={'100%'}
                borderRadius={'2px'}
                color={'#DA4453'}
              >
                削除
              </Typography>
            </Button>
          )} */}
          </Stack>
        </Stack>
      </Stack>
      <DialogForm
        open={openForm}
        handleClose={handleCloseDialogForm}
        submission_id={logAnswer?.submission_id}
        handleConfirm={handleSubmitForm}
      />
    </>
  );
};

export default PatientAnswers;
